export default {"src":"/_next/static/media/clock.9be0ecae.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};